var _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white",
    stroke: "#C3D4E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 7.5,
    r: 5.5,
    fill: "#FF4423"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0201 12.91C18.7101 12.91 16.0201 15.6 16.0201 18.91V21.8C16.0201 22.41 15.7601 23.34 15.4501 23.86L14.3001 25.77C13.5901 26.95 14.0801 28.26 15.3801 28.7C19.6901 30.14 24.3401 30.14 28.6501 28.7C29.8601 28.3 30.3901 26.87 29.7301 25.77L28.5801 23.86C28.2801 23.34 28.0201 22.41 28.0201 21.8V18.91C28.0201 15.61 25.3201 12.91 22.0201 12.91Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8699 13.1999C23.5599 13.1099 23.2399 13.0399 22.9099 12.9999C21.9499 12.8799 21.0299 12.9499 20.1699 13.1999C20.4599 12.4599 21.1799 11.9399 22.0199 11.9399C22.8599 11.9399 23.5799 12.4599 23.8699 13.1999Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.02 29.0601C25.02 30.7101 23.67 32.0601 22.02 32.0601C21.2 32.0601 20.44 31.7201 19.9 31.1801C19.36 30.6401 19.02 29.8801 19.02 29.0601",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.dd106581bdfbca5d6ebbb5c51bdd18a4.svg";
export { ForwardRef as ReactComponent };